import { render, staticRenderFns } from "./TextNoneIcon.vue?vue&type=template&id=79fa6dde&"
import script from "./TextNoneIcon.vue?vue&type=script&lang=js&"
export * from "./TextNoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports